@if (showOtpComponent) {
  <ng-otp-input
    #ngOtpInput
    class="form-control"
    [class.is-invalid]="hasError"
    [config]="config"
    (blur)="onBlur()"
    [disabled]="disabled"
    [ngModel]="value"
    tabindex="0"
    ngbAutofocus
    (onInputChange)="onOtpChange($event)"
  ></ng-otp-input>
}
